<template>
      <v-container fluid class="fill-height">
      <v-row>
        <v-col class="d-flex justify-center text-center" cols="12">
          <TyperWrapper :text="text" @typed="next=true"></TyperWrapper>
        </v-col>
        <v-row>
          <v-col class="d-flex justify-center text-center">
            <v-fade-transition>
            <v-container>
              <router-link to="/quiz">
                <v-btn
                  rounded
                  color="primary"
                  v-if="next"
                  x-large
                >
                  Continue <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </router-link>
            </v-container>
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
</template>
<script>

import TyperWrapper from '../components/TyperWrapper.vue'

export default {
    props: ['pass'],
    components:{
      TyperWrapper
    },
    data: () => ({
      text:"Sleep impacts every aspect of your life, from your physical health to your mental clarity, productivity, and emotional well-being. Yet, achieving restful and restorative sleep can be challenging, especially in today's fast-paced world. I am your personalized sleep companion designed to improve your sleep patterns, boost your energy levels, and enhance your overall well-being",
      countWord: 0,
      next:false
    }),
    methods: {
      typed(){
        this.next=true
      },
       
    }
  };
  
  </script>
